module.exports = __webpack_public_path__ + "img/boton_crear_cedi.b0c8685c.svg";